import { FruitConfig } from "../../../../actions/Tenants/config/constantsTyped";

export const defaultFruitType = {
    text: "Avocado",
    value: "avocado",
    a_fruit: "an avocado",
    n: "avocados",
    n_cap: "Avocados",
    external_colors: [],
    internal_colors: [],
    firmness_class: [],
    default_variety: ""
} as FruitConfig;
